/**
 * Pre-configured axios instance with authentication interceptor.
 *
 * This module provides a centralized axios instance that automatically
 * injects the auth token from localStorage into all requests, eliminating
 * the need to manually call setAuthToken before each API call.
 *
 * Usage:
 *   import api from '../utils/api';
 *   const response = await api.get('/endpoint/');
 *   const data = await api.post('/endpoint/', { data });
 */

import axios from 'axios'
import API_URL from '../config'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for error handling (optional enhancement)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized - token may have expired
    if (error.response && error.response.status === 401) {
      // Could trigger logout or token refresh here if needed
      console.error('Authentication error - token may have expired')
    }
    return Promise.reject(error)
  }
)

export default api
